export default {
  download: 'Descargar',
  forward: 'Avanzar',
  forward_link: 'Reenviar enlace',
  forward_image: 'Reenviar imagen',
  forward_file: 'Reenviar archivo',
  forward_message: 'Reenviar mensaje',
};
